import { memo } from "react";
import {
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
} from "@/shared/components/ui/table";
import { CommercialInvoiceRow } from "./CommercialInvoiceRow";
import { useNow } from "../hooks/useNow";
import type { CommercialInvoiceResponseDTO } from "../types/commercial-invoice.types";

interface CommercialInvoicesTableProps {
  invoices: CommercialInvoiceResponseDTO[];
  refreshingId: number | null;
  onRefresh: (invoice: CommercialInvoiceResponseDTO) => void;
  onCancel: (invoice: CommercialInvoiceResponseDTO) => void;
}

export const CommercialInvoicesTable = memo(function CommercialInvoicesTable({
  invoices,
  refreshingId,
  onRefresh,
  onCancel,
}: CommercialInvoicesTableProps) {
  const hasCancellationWindowRunning = invoices.some(
    (invoice) => invoice.status === "ISSUED",
  );
  const now = useNow(hasCancellationWindowRunning);

  return (
    <div className="overflow-x-auto">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>#</TableHead>
            <TableHead>Comprador</TableHead>
            <TableHead>Status</TableHead>
            <TableHead>Pagamento</TableHead>
            <TableHead className="pr-6 text-right">Valor</TableHead>
            <TableHead>Nota</TableHead>
            <TableHead>Criada em</TableHead>
            <TableHead>Documentos</TableHead>
            <TableHead className="text-right">Ações</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {invoices.map((invoice) => (
            <CommercialInvoiceRow
              key={invoice.id}
              invoice={invoice}
              now={now}
              refreshing={refreshingId === invoice.id}
              onRefresh={onRefresh}
              onCancel={onCancel}
            />
          ))}
        </TableBody>
      </Table>
    </div>
  );
});
